<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="列表" name="second">
				<div class="grid-height">
					<vxe-grid ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl"></div>
								<div class="fr">
									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
									<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent">
								<vxe-form-item title="菜单名称:" field="menuName">
									<template v-slot>
										<el-input v-model="formData.menuName" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="菜单编码:" field="menuCode">
									<template v-slot>
										<el-input v-model="formData.menuCode" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="是否启用:" field="enabled">
									<template v-slot>
										<el-select v-model="formData.enabled" clearable>
											<el-option value="true" label="启用"></el-option>
											<el-option value="false" label="禁用"></el-option>
										</el-select>
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
						<template #listImage="obj">
							<baseUpload
								v-if="obj.row.categoryImageUrl"
								accept="image/png, image/jpeg"
								multi="false"
								edit="false"
								dataType="medium"
								:file.sync="obj.row.categoryImageUrl"
							></baseUpload>
						</template>
						<template #editImage="obj">
							<baseUpload accept="image/png, image/jpeg" multi="false" dataType="medium" :file.sync="obj.row.categoryImageUrl"></baseUpload>
						</template>
						<template #operate="obj">
							<div class="cell-operate">
								<template v-if="$refs['table-m1'].isActiveByRow(obj.row)">
									<a @click="saveRowEvent(obj)" class="a-link" data-tit="保存">
										<el-tooltip :enterable="false" effect="dark" content="保存" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-circle-check"></i>
										</el-tooltip>
									</a>
									<a @click="cancleRowEvent(obj)" class="a-link" data-tit="取消行编辑" v-if="hasSaveRow(obj.row)">
										<el-tooltip :enterable="false" effect="dark" content="取消行编辑" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-circle-close"></i>
										</el-tooltip>
									</a>
									<a @click="removeRowEvent(obj)" class="a-link" data-tit="删除" v-if="!hasSaveRow(obj.row)">
										<el-tooltip :enterable="false" effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-delete"></i>
										</el-tooltip>
									</a>
								</template>
								<template v-else>
									<a class="a-link" data-tit="新增" @click="insertChildEvent(obj)">
										<el-tooltip :enterable="false" effect="dark" content="新增" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-circle-plus-outline"></i>
										</el-tooltip>
									</a>
									<a @click="editRowEvent(obj)" class="a-link" data-tit="行编辑" v-if="obj.row && !obj.row.is_top">
										<el-tooltip :enterable="false" effect="dark" content="行编辑" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-edit-outline"></i>
										</el-tooltip>
									</a>
								</template>
							</div>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import { tableTreeMixins } from '@/mixins/tableTree/index.js';

export default {
	name: 'menu:list',
	components: {},
	mixins: [tableTreeMixins],
	mounted() {
		this.initTableList();
	},
	data() {
		let that = this;
		return {
			activeName: 'second',
			dataId: '',
			formData: {},
			vxeOption: {}
		};
	},
	methods: {
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');
		},
		resetEvent() {
			this.formData = {};
			this.$refs['table-m1'].commitProxy('reload');
		},
		initTableList() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'user_menu_list-m1',
				path: USER_PREFIX + '/menu/list',
				treeNodeUrl: USER_PREFIX + '/menu/listChildren',
				param: () => {
					return this.formData;
				},
				treeNodeParam: row => {
					return {
						parent: row.id,
						enabled: this.formData.enabled
					};
				},
				// config: {
				// 	treeConfig: {
				// 		parentField: 'parent'
				// 	}
				// },
				columns: [
					{ type: 'checkbox', width: 48, resizable: false, fixed: 'left' },
					{
						title: '菜单名称',
						field: 'menuName',
						width: 250,
						fixed: 'left',
						treeNode: true
					},
					{
						field: 'menuCode',
						title: '菜单编码',
						width: 250
					},
					{ field: 'url', title: '菜单地址', width: 200 },
					{
						field: 'enabled',
						title: '是否启用',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.enabled) {
									return [<div class="txt-status">启用</div>];
								} else {
									return [<div class="txt-status s-3">禁用</div>];
								}
							}
						}
					},
					// { field: 'treePathName', title: '上级菜单', width: 200 },
					{ field: 'orders', title: '序号', width: 100, editRender: { name: 'input' } },
					{
						field: 'type',
						title: '类型',
						width: 100,
						slots: {
							default: ({ row }) => {
								var val = row.type;
								var html = '';
								if (val == 0) {
									html = '菜单';
								} else if (val == 1) {
									html = '按钮';
								}
								return html;
							}
						}
					},
					{ title: '创建时间', field: 'createDate', width: 200 },
					// { title: '更新人', field: 'modifyBy', width: 100 },
					// { title: '更新时间', field: 'modifyDate', width: 200 },
					{
						width: 47,
						title: '',
						fixed: 'right',
						sortable: false
						// slots: { default: 'operate' }
					}
				]
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				this.vxeOption = opts;
			});
		}
	}
};
</script>
